var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M8.001 0A7.978 7.978 0 0 0 0 8.001 7.977 7.977 0 0 0 8.001 16 7.977 7.977 0 0 0 16 8.001 7.977 7.977 0 0 0 8.001 0zm3.526 7.165l-.51.507a.35.35 0 0 1-.507 0L9.056 6.218c-.11-.108-.329-.035-.329.146v6c0 .218-.145.364-.364.364h-.726c-.219 0-.364-.146-.364-.364V6.328c0-.145-.181-.256-.327-.145L5.49 7.637a.35.35 0 0 1-.508 0l-.51-.51a.33.33 0 0 1-.107-.254.33.33 0 0 1 .108-.255l3.272-3.273a.394.394 0 0 1 .256-.108c.108 0 .181.035.254.108l3.272 3.273a.33.33 0 0 1 .11.255c0 .146-.037.219-.11.292z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.6dfb30d31e39b626a6dc9a168c436f61.svg";
export { ForwardRef as ReactComponent };